export const tabColors = {
  COLLECTION: '#88AACD',
  CANVAS: '#009E77',
  CAROUSEL: '#9D6EAA',
  CINEMA: '#E0A200',
  STILL: '#D25556',
  VIDEO: '#78C6D9',
  HOLIDAY: '#D2229A',
  LEASE: '#FFFD67',
  OTHER: '#A2A2A2',
  ORGANIC: '#FFB6C1',
};

export const getCategoryByName = (ad) => {
  const adName = ad.ad_name.toLowerCase();
  switch (true) {
    case adName.split('organic').length > 1:
      return 'ORGANIC';
    case adName.split('lease special').length > 1 || adName.split('lease specials').length > 1 || adName.split('leasing specials').length > 1:
      return 'LEASE';
    case ad.campaignObjective === 'VIDEO_VIEWS':
      return 'VIDEO';
    case adName.split('collection').length > 1:
      return 'COLLECTION';
    case adName.split('canvas').length > 1:
      return 'CANVAS';
    case adName.split('carousel').length > 1:
      return 'CAROUSEL';
    case adName.split('cinema').length > 1:
      return 'CINEMA';
    case adName.split('still').length > 1:
      return 'STILL';
    case adName.split('holiday').length > 1:
      return 'HOLIDAY';
    default:
      return 'OTHER';
  }
};

export const getActiveTabs = (tabs) => {
  const activeTabs = [];

  if (tabs.COLLECTION.length > 0) {
    activeTabs.push('Collection');
  }

  if (tabs.CANVAS.length > 0) {
    activeTabs.push('Canvas');
  }

  if (tabs.CAROUSEL.length > 0) {
    activeTabs.push('Carousel');
  }

  if (tabs.CINEMA.length > 0) {
    activeTabs.push('Cinema');
  }

  if (tabs.STILL.length > 0) {
    activeTabs.push('Still');
  }

  if (tabs.VIDEO.length > 0) {
    activeTabs.push('Video');
  }

  if (tabs.HOLIDAY.length > 0) {
    activeTabs.push('Holiday');
  }

  if (tabs.LEASE.length > 0) {
    activeTabs.push('Lease');
  }

  if (tabs.OTHER.length > 0) {
    activeTabs.push('Other');
  }

  if (tabs.ORGANIC.length > 0) {
    activeTabs.push('Organic');
  }

  return activeTabs;
};



// WEBPACK FOOTER //
// ./src/screens/Organic/OrganicAdSorting.js